import PropertyWidget from "csi/property/Widget";
import declare from "dojo/_base/declare";
import monitor from "csi/monitor/_base";

const Properties = declare(PropertyWidget, {

	generating: false,

	/**
	 * @override
	 * If Supplier Request is issuing and generating PDFs, refresh properties view when finished
	 */
	onViewCreate() {
		this.own(monitor.onChangeNode(this.urlRoot, (node) => {
			if (node && node.State === "SupplierRequestState:Generating") {
				this.generating = true;
			}

			// refresh widget only once when transitioning from generating to issued
			if (this.generating && node && node.State === "SupplierRequestState:Issued") {
				this.generating = false;
				this.refreshWidget();
			}
		}));
	},
});

export = Properties;
